import { createClient } from "@sanity/client";

export default createClient({
	apiVersion: "2024-12-05",
	projectId: process.env.NEXT_PUBLIC_PROJECTID, // you can find this in sanity.json
	dataset: process.env.NEXT_PUBLIC_DATASET, // or the name you chose in step 1
	useCdn: true, // `false` if you want to ensure fresh data
});
